/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Eliminaciones movidas a otras acciones
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DirectionsIcon from "@mui/icons-material/Directions";
import VerifiedIcon from "@mui/icons-material/Verified";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from '@mui/icons-material/Print';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

import { Fragment } from "react";
import { useSesion } from "../../context/System/SesionContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from '../../hooks/useDoubleClickPrevention';

export default function MnuPreVentasActions() {
    const { getPermisoBoton, getNombreBoton } = useSesion();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
    const {
        handleClickRegresarMainDashboard,
        handleClickRefrescarDatosPreVenta,
        handleArirModalFirmaPreVenta,
        handleArirModalBuscarArticulosPreventas,
        handleArirModalBuscarCliente,
        handleAbrirMenuModalPreventa,
        setMostrarBuscadorArticulos,
    } = useVentas();

    const handeAbrirBuscadorarticulos = () => {    
        setMostrarBuscadorArticulos(true);
        handleArirModalBuscarArticulosPreventas();
    }

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon"> Salir</p>
                </IconButton>
            </Tooltip>           
            <Tooltip title={"Firmar preventa"}>
                <IconButton onClick={() => executeWithProtection(handleArirModalFirmaPreVenta)} disabled={isProcessing}>
                    <VerifiedIcon className="icon" /><p className="icon">Firmar preventa</p>
                </IconButton>
            </Tooltip>
            <Tooltip title="Refrescar datos">
                <IconButton onClick={handleClickRefrescarDatosPreVenta}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip> 
            <Tooltip title="Buscar artículos">
                <IconButton onClick={handeAbrirBuscadorarticulos}>
                    <SearchIcon className="icon" /><p className="icon">Artíulos</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={"Buscar Clientes (Alt+F2)"}>
                <IconButton onClick={handleArirModalBuscarCliente}>
                    <PersonSearchIcon className="icon" /><p className="icon">Clientes</p>
                </IconButton>
            </Tooltip> 
            {/* <Tooltip title="Jalar preventas">
                <IconButton onClick={handleAbrirModalRecuperarPreVentaFirma}>
                    <SearchIcon className="icon" />
                </IconButton>
            </Tooltip>  */}
            <Tooltip title={"acciones_venta"}>
                <IconButton onClick={handleAbrirMenuModalPreventa} >
                    <DensitySmallIcon className="icon" /><p className="icon">Menu</p>
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}
